<template>
  <div v-if="isExternalLink">
    <a :href="url" :class="classList">
      <i :class="icon"></i> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
    </a>
  </div>
  <div v-else>
    <router-link :to="url" :class="classList">
      <i :class="icon"></i> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
    </router-link>
  </div>
</template>

<script>
  import { resolveHTTP } from '@/services/api'
  import { has } from 'lodash'

  export default {
    name: 'sidebar-nav-link',
    props: {
      name: {
        type: String,
        default: ''
      },
      url: {
        type: String | Object,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      badge: {
        type: Object,
        default: () => {}
      },
      variant: {
        type: String,
        default: ''
      },
      classes: {
        type: String,
        default: ''
      }
    },
    computed: {
      classList () {
        return [
          'nav-link',
          this.linkVariant,
          ...this.itemClasses
        ]
      },
      linkVariant () {
        return this.variant ? `nav-link-${this.variant}` : ''
      },
      itemClasses () {
        return this.classes ? this.classes.split(' ') : []
      },
      isExternalLink () {
        if (this.url.substring) {
          if (this.url.substring(0, 4) === 'http') {
            return true
          } else {
            return false
          }
        }
      }
    },
    mounted () {
      let self = this
      if (has(self.badge, 'entity')) {
        let Api = resolveHTTP(self.badge.entity)
        Api.index({
          params: {
            'per_page': 1,
            '_search[]': self.badge.search || null
          }
        }).then((res, body) => {
          self.badge.text = res.data.pagination.total
        }).catch((error) => {
          self.error = error
          return null
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  .sidebar .nav-link.active i,
  .sidebar .navbar .active.dropdown-toggle i,
  .navbar .sidebar .active.dropdown-toggle i
    color: #fff
  
  .nav-link 
    transition: none
</style>



// WEBPACK FOOTER //
// src/components/core/Sidebar/SidebarNavLink.vue